export const SET_HOVERED_TABLE_CELL = 'SET_HOVERED_TABLE_CELL';
export const RESET_HOVERED_TABLE_CELL = 'RESET_HOVERED_TABLE_CELL';

export const ADD_ACTIVE_TABLE_ROW = 'ADD_ACTIVE_TABLE_ROW';
export const REMOVE_ACTIVE_TABLE_ROW = 'REMOVE_ACTIVE_TABLE_ROW';

export const SET_SELECTED_TABLE_COLUMN_NAME = 'SET_SELECTED_TABLE_COLUMN_NAME';
export const SET_SELECTED_TABLE_CELL = 'SET_SELECTED_TABLE_CELL';
export const ADD_SELECTED_TABLE_ROW = 'ADD_SELECTED_TABLE_ROW';
export const REMOVE_SELECTED_TABLE_ROW = 'REMOVE_SELECTED_TABLE_ROW';

export const RESET_SELECTED_TABLE_CELLS = 'RESET_SELECTED_TABLE_CELLS';
